import { lazy } from "react";
export const Login = lazy(() => import("../features/Login/main"));
export const Reset = lazy(
  () => import("../features/Login/components/Reset/main"),
);
export const ManageFarmers = lazy(() => import("./manage_farmers/main"));
export const ManageSurveyors = lazy(() => import("./manage_surveyors/main"));
export const Summary = lazy(() => import("./Summary/main"));

export { default as AppLayout } from "./layout/main";
